// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import LiveCursorNameTag from './LiveCursorNameTag';
import Icon from '../../../../components/icons/Icon';

// Styles
import './LiveCursorTypeEraser.scss';

const LiveCursorTypeEraser = ({ user }) => (
    <div className="cursor LiveCursorTypeEraser">
        <Icon name="cursor-remote-eraser" />
        <LiveCursorNameTag user={user} />
    </div>
);

LiveCursorTypeEraser.propTypes = {
    user: PropTypes.object,
};

export default LiveCursorTypeEraser;
